import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';
import { LocationTypeEnum } from '../../../tenant/locations/enums/location-type.enum';

/**
 * Location DTO for records
 */
@CaslSubject(AppSubjectEnum.LOCATION)
export class ProtoLocationRecordDto extends BaseProtoDto {
  areaUuid!: string;
  gpsPoint!: string;
  name!: string;
  geoLocationName?: string;
  type?: LocationTypeEnum;
  isPickUp!: boolean;
  isDropOff!: boolean;
  isPrivate!: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}
